module.exports = __webpack_public_path__ + "img/default-user-avatar.79fd52e3.jpg";